import { render, staticRenderFns } from "./SalePricesRules.vue?vue&type=template&id=aa81ad88"
import script from "./SalePricesRules.vue?vue&type=script&lang=js"
export * from "./SalePricesRules.vue?vue&type=script&lang=js"
import style0 from "./SalePricesRules.vue?vue&type=style&index=0&id=aa81ad88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports